import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from '../../core/http/http.service';
import { UserApiUrls } from '../constants/user-api-url.constant';
import { User } from '../models/user.model';
import { SiteUser } from '../models/usersites.model';
import { PagedInput } from '../models/page-input.model';
import { PagedResult } from '../models/paged-result.model';
import { TileItem } from '../../reference/models/tileItem';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  availableTiles!: TileItem[];


  constructor(private httpService: HttpService) {

  }

  getUsers(search?: User, pageData?: PagedInput): Observable<PagedResult<User>> {
    if (!pageData) {
      pageData = {
        pageSize: 10,
        currentPage: 1
      };
    }

    return this.httpService.post(`${UserApiUrls.users}`, Object.assign(pageData, search));
  }

  save(user: User): Observable<boolean> {
    return this.httpService.post(UserApiUrls.save, user);
  }

  getRoles(userId: string): Observable<string[]> {
    return this.httpService.get(`${UserApiUrls.roles}/${userId}/role`);
  }

  postUsersInRole(userId: string, roleName: string): Observable<boolean> {
    console.log(`User Id ${userId} Role ${roleName}`);
    return this.httpService.post(`${UserApiUrls.assignrole}/${userId}/${roleName}`);
  }

  checkUsernameExists(userName: string): Observable<boolean> {
    return this.httpService.get(`${UserApiUrls.usernameexsist}/${userName}`);
  }

  checkNumExists(number: string, id: number, isUpdate: boolean): Observable<boolean> {
    if (isUpdate) {
      return this.httpService.get(`${UserApiUrls.usernumexists}/${number}/${id}/`);
    } else {
      return this.httpService.get(`${UserApiUrls.usernumexists}/${number}`);
    }
  }

  // getSiteByUserId(userId: string): Observable<SiteUser[]> {
  //   return this.httpService.get(`${UserApiUrls.usersites}/${userId}`);
  // }

  saveSiteUser(selected: SiteUser[]): Observable<boolean> {
    return this.httpService.post(UserApiUrls.saveusersites, selected);
  }

  getUsersByRole(roleName: string): Observable<User[]> {
    return this.httpService.get(`${UserApiUrls.usersbyrole}/${roleName}`);
  }

  getRegions(): Observable<any[]> {
    return this.httpService.get<any[]>(UserApiUrls.regions);
  }

  getOrganisations(): Observable<any[]> {
    return this.httpService.get<any[]>(UserApiUrls.organisations);
  }


  getUserOrganisations(): Observable<any[]> {
    return this.httpService.get<any[]>(UserApiUrls.organisations);
  }
}
